import { Stethoscope } from 'lucide-react';

interface DiagnosticToggleFabProps {
  isOpen: boolean;
  onClick: () => void;
}

export function DiagnosticToggleFab({ isOpen, onClick }: DiagnosticToggleFabProps) {
  const baseClasses = 'fixed top-2 z-[150] flex h-8 items-center gap-1.5 rounded-full border bg-zinc-900/90 px-3 text-xs backdrop-blur-sm shadow-[0_2px_10px_rgba(0,0,0,0.5)] transition-colors';
  const stateClasses = isOpen
    ? 'border-cyan-500/60 text-cyan-300 bg-zinc-800/95'
    : 'border-cyan-500/30 text-zinc-300 hover:border-cyan-500/60 hover:text-cyan-300 hover:bg-zinc-800/90';

  return (
    <button
      type="button"
      onClick={onClick}
      style={{ left: 'calc(50% + 60px)' }}
      className={`${baseClasses} ${stateClasses}`}
      aria-label={isOpen ? 'Close diagnostics' : 'Open diagnostics'}
      aria-pressed={isOpen}
    >
      <Stethoscope size={14} className={isOpen ? 'animate-pulse' : ''} />
      <span>Diag</span>
    </button>
  );
}
